import { AlpineComponent } from '@alpinejs/csp';

const Video = (): AlpineComponent => ({
  isPlaying: false,
  onClickPlay() {
    this.isPlaying = true;
    if (this.$refs.video) this.$refs.video.play();
  },
  getClassName() {
    return { 'video--is-playing': this.isPlaying };
  }
});

export default Video;
